// eslint-disable-next-line no-undef
export default JSON.parse(process.env.REACT_APP_CLIENT_CREDENTIALS);
